import {
  AfterViewInit,
  Component,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-unauthenticated-container',
  templateUrl: './unauthenticated-container.component.html',
  styleUrls: ['./unauthenticated-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UnauthenticatedContainerComponent
  implements OnInit, AfterViewInit
{
  isAuthenticated: boolean = false;
  constructor() {}

  ngOnInit(): void {}
  ngAfterViewInit(): void {}
}
